import { render } from "./emailList.vue?vue&type=template&id=44c84cca&scoped=true"
import script from "./emailList.vue?vue&type=script&lang=js"
export * from "./emailList.vue?vue&type=script&lang=js"

import "./emailList.vue?vue&type=style&index=0&id=44c84cca&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c84cca"]])

export default __exports__